import React from "react"

import Headline from "./headline"
import Editor from "./editor"
import { Wrapper } from "./styles"

const Top = ({ article }) => {
  const {
    subcategory,
    titles: { body: bodyTitle, site: siteTitle },
    partner,
    sponsor,
    authors,
    reviewers, // Medicals, Experts, Fact-checked articles
    personalStory, // Personal story articles
    publishDateFormatted,
    lastModifiedFormatted,
    children: imagesGatsby,
  } = article

  const author = authors && authors[0]
  const reviewer = reviewers && reviewers[0]

  return (
    <Wrapper>
      <Headline
        title={bodyTitle || siteTitle}
        partner={partner}
        sponsor={sponsor}
        subcategory={subcategory}
        reviewer={reviewer}
        personalStory={personalStory}
        imagesGatsby={imagesGatsby}
      />
      <Editor
        partner={partner}
        sponsor={sponsor}
        author={author}
        reviewer={reviewer}
        lastModifiedFormatted={lastModifiedFormatted}
        publishDateFormatted={publishDateFormatted}
        imagesGatsby={imagesGatsby}
      />
    </Wrapper>
  )
}
export default React.memo(Top)
